import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import intl from 'react-intl-universal';
import { useLatest } from 'ahooks';
import {
  PrivilegeStatus,
  SwitchLabel,
  SwitchLabelForStaff,
  SwitchLabelForDoctor,
  SwitchLabelToPrivilege,
  SwitchLableToTranslationKey,
} from 'shared/constants/privilege';

import SwitchWithLabels from 'views/PersonalSettings/components/Switch';
import { Stack } from '@mui/material';
import logger from 'utils/logger';
import { UserType } from 'shared/constants/users';

const propTypes = {
  privilegeDetails: PropTypes.object.isRequired,
  privilege: PropTypes.object,
  onPrivilegeChange: PropTypes.func.isRequired,
};

const log = logger.createLogger(
  'DashboardOrganizationSettingsUserManagementPrivilege'
);

const DashboardOrganizationSettingsUserManagementPrivilege = ({
  privilegeDetails,
  privilege,
  onPrivilegeChange,
}) => {
  //! The privilegeDetails have also employment data
  const { user, employment } = privilegeDetails;
  const latestPrivilege = useLatest(privilege);

  const userType = employment.userType ? employment.userType : user.userType;

  //! The switch labels will only show the possible selections
  const switchLabels =
    userType === UserType.STAFF
      ? Object.keys(SwitchLabelForStaff)
      : userType === UserType.DOCTOR
      ? Object.keys(SwitchLabelForDoctor)
      : Object.keys(SwitchLabel);

  const handleChangePrivilegeStatus = (switchLabel) => {
    const newPrivilege = { ...latestPrivilege.current };
    const selectedPrivilegeKeys = SwitchLabelToPrivilege[switchLabel];
    newPrivilege[switchLabel] =
      latestPrivilege.current[switchLabel] === PrivilegeStatus.ON
        ? PrivilegeStatus.OFF
        : PrivilegeStatus.ON;
    selectedPrivilegeKeys.forEach((key) => {
      newPrivilege[key] = newPrivilege[switchLabel];
    });
    onPrivilegeChange(newPrivilege);
  };

  return (
    <Stack>
      <Typography
        variant="h4"
        style={{
          fontWeight: 'bold',
          textAlign: 'center',
        }}>
        {`${user.firstName + ' ' + user.lastName}`}
      </Typography>

      {switchLabels.map((label) => {
        return (
          <Grid container key={label} sx={{ margin: 1 }}>
            <Grid size={8}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start">
                <Typography
                  variant="h6"
                  gutterBottom
                  component="div"
                  style={{
                    fontWeight: 'bold',
                    textAlign: 'left',
                  }}>
                  {intl.get(SwitchLableToTranslationKey[label])}
                </Typography>
              </Stack>
            </Grid>
            <Grid>
              <SwitchWithLabels
                preferences={{
                  [label]: {
                    switch: privilege?.[label] === PrivilegeStatus.ON,
                  },
                }}
                service={label}
                notificationKey={label}
                channel="switch"
                handleChangePreference={() => {
                  handleChangePrivilegeStatus(label);
                }}
              />
            </Grid>
          </Grid>
        );
      })}
    </Stack>
  );
};

DashboardOrganizationSettingsUserManagementPrivilege.propTypes = propTypes;

export default DashboardOrganizationSettingsUserManagementPrivilege;
